"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DidYouMean = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const React = require("react");
const index_1 = require("../../Pages/index");
const clsx_1 = require("clsx");
const DidYouMean = ({ suggestions, selectedFiltersQueryString, additionalClassNames, }) => {
    const newSearchValues = React.useMemo(() => [
        {
            key: 'query',
            value: suggestions,
        },
        {
            key: 'isInitialSearch',
            value: 'true',
        },
    ], [suggestions]);
    const suggestionLink = React.useMemo(() => app_1.UrlService.ReplaceOrAddPairsOfKeyValuesInUrl(selectedFiltersQueryString, newSearchValues), [newSearchValues, selectedFiltersQueryString]);
    const didYouMeanMessage = index_1.PageContext.filterableDictionary.didYouMeanMessage;
    if (!suggestions)
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, clsx_1.clsx)('list-total-count mt-4 md:mt-0 shrink', additionalClassNames), children: [didYouMeanMessage, (0, jsx_runtime_1.jsx)("a", { className: "link-primary ml-1.5", href: suggestionLink, children: suggestions }), "?"] }));
};
exports.DidYouMean = DidYouMean;
